import { render, staticRenderFns } from "./btn-base.vue?vue&type=template&id=84a2180e&scoped=true"
import script from "./btn-base.vue?vue&type=script&lang=ts"
export * from "./btn-base.vue?vue&type=script&lang=ts"
import style0 from "./btn-base.vue?vue&type=style&index=0&id=84a2180e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a2180e",
  null
  
)

export default component.exports